var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoChatRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 58 58",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAED",
    d: "M19.8 36.424h11.43v-2.416H19.8zm0-4.591h17.4v-2.417H19.8zm0-4.592h17.4v-2.417H19.8zM14 48V21.417q0-.98.719-1.698.72-.72 1.698-.719h24.166q.98 0 1.698.719.72.72.719 1.698v18.366q0 .98-.719 1.698-.72.72-1.698.719H19.8zm4.76-8.217h21.823V21.417H16.417V42.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChatRoom);
export default __webpack_public_path__ + "static/media/IcoChatRoom.0ad8cafbff4045495720affc6bc6d2d4.svg";
export { ForwardRef as ReactComponent };